export default {
  all: 'All',
  games: 'Games',
  playedRecently: 'Played recently',
  typePrizeDrop: 'Drops',
  typeRoulette: 'Roulette',
  typeSlingshot: 'Slingshot',
  typeSlot: 'Slots',
};
